/**
 * aiscShapeData.js
 * ================
 * AISC Steel Construction Manual 16th Edition — Standard Shape Database
 * Used by AddInventory / EditInventory for autofill of:
 *   - AISC Manual Label
 *   - Weight (lbs/ft)
 *   - Depth (d, inches)
 *   - Shape type (for dropdown auto-select)
 *
 * Key format: uppercase, no spaces.  e.g. "W8X31", "HSS4X4X1/4", "L3X3X1/4"
 * Entry format: [weight_lbs_per_ft, depth_inches, aisc_label, shape_code]
 *
 * Source: AISC Steel Construction Manual, 16th Edition, Tables 1-1 through 1-24
 */

// ─── Lookup table ─────────────────────────────────────────────────────────────
// [weight, d, label, shape]
const RAW = {

  // ══ W SHAPES ══════════════════════════════════════════════════════════════
  "W4X13":   [13,   4.16, "W4x13",   "W"], "W4X19":   [19,   4.53, "W4x19",   "W"],
  "W5X16":   [16,   5.01, "W5x16",   "W"], "W5X19":   [19,   5.15, "W5x19",   "W"],
  "W6X8.5":  [8.5,  5.83, "W6x8.5",  "W"], "W6X9":    [9,    5.90, "W6x9",    "W"],
  "W6X12":   [12,   6.03, "W6x12",   "W"], "W6X15":   [15,   5.99, "W6x15",   "W"],
  "W6X16":   [16,   6.28, "W6x16",   "W"], "W6X20":   [20,   6.20, "W6x20",   "W"],
  "W6X25":   [25,   6.38, "W6x25",   "W"],
  "W8X10":   [10,   7.89, "W8x10",   "W"], "W8X13":   [13,   7.99, "W8x13",   "W"],
  "W8X15":   [15,   8.11, "W8x15",   "W"], "W8X18":   [18,   8.14, "W8x18",   "W"],
  "W8X21":   [21,   8.28, "W8x21",   "W"], "W8X24":   [24,   7.93, "W8x24",   "W"],
  "W8X28":   [28,   8.06, "W8x28",   "W"], "W8X31":   [31,   8.00, "W8x31",   "W"],
  "W8X35":   [35,   8.12, "W8x35",   "W"], "W8X40":   [40,   8.25, "W8x40",   "W"],
  "W8X48":   [48,   8.50, "W8x48",   "W"], "W8X58":   [58,   8.75, "W8x58",   "W"],
  "W8X67":   [67,   9.00, "W8x67",   "W"],
  "W10X12":  [12,   9.87, "W10x12",  "W"], "W10X15":  [15,   9.99, "W10x15",  "W"],
  "W10X17":  [17,  10.1,  "W10x17",  "W"], "W10X19":  [19,  10.2,  "W10x19",  "W"],
  "W10X22":  [22,  10.2,  "W10x22",  "W"], "W10X26":  [26,  10.3,  "W10x26",  "W"],
  "W10X30":  [30,  10.5,  "W10x30",  "W"], "W10X33":  [33,   9.73, "W10x33",  "W"],
  "W10X39":  [39,   9.92, "W10x39",  "W"], "W10X45":  [45,  10.1,  "W10x45",  "W"],
  "W10X49":  [49,  10.0,  "W10x49",  "W"], "W10X54":  [54,  10.1,  "W10x54",  "W"],
  "W10X60":  [60,  10.2,  "W10x60",  "W"], "W10X68":  [68,  10.4,  "W10x68",  "W"],
  "W10X77":  [77,  10.6,  "W10x77",  "W"], "W10X88":  [88,  10.8,  "W10x88",  "W"],
  "W10X100": [100, 11.1,  "W10x100", "W"], "W10X112": [112, 11.4,  "W10x112", "W"],
  "W12X14":  [14,  11.9,  "W12x14",  "W"], "W12X16":  [16,  12.0,  "W12x16",  "W"],
  "W12X19":  [19,  12.2,  "W12x19",  "W"], "W12X22":  [22,  12.3,  "W12x22",  "W"],
  "W12X26":  [26,  12.2,  "W12x26",  "W"], "W12X30":  [30,  12.3,  "W12x30",  "W"],
  "W12X35":  [35,  12.5,  "W12x35",  "W"], "W12X40":  [40,  11.9,  "W12x40",  "W"],
  "W12X45":  [45,  12.1,  "W12x45",  "W"], "W12X50":  [50,  12.2,  "W12x50",  "W"],
  "W12X53":  [53,  12.1,  "W12x53",  "W"], "W12X58":  [58,  12.2,  "W12x58",  "W"],
  "W12X65":  [65,  12.1,  "W12x65",  "W"], "W12X72":  [72,  12.3,  "W12x72",  "W"],
  "W12X79":  [79,  12.4,  "W12x79",  "W"], "W12X87":  [87,  12.5,  "W12x87",  "W"],
  "W12X96":  [96,  12.7,  "W12x96",  "W"], "W12X106": [106, 12.9,  "W12x106", "W"],
  "W12X120": [120, 13.1,  "W12x120", "W"], "W12X136": [136, 13.4,  "W12x136", "W"],
  "W12X152": [152, 13.7,  "W12x152", "W"], "W12X170": [170, 14.0,  "W12x170", "W"],
  "W12X190": [190, 14.4,  "W12x190", "W"], "W12X210": [210, 14.7,  "W12x210", "W"],
  "W12X230": [230, 15.1,  "W12x230", "W"], "W12X252": [252, 15.4,  "W12x252", "W"],
  "W12X279": [279, 15.9,  "W12x279", "W"], "W12X305": [305, 16.3,  "W12x305", "W"],
  "W12X336": [336, 16.8,  "W12x336", "W"],
  "W14X22":  [22,  13.7,  "W14x22",  "W"], "W14X26":  [26,  13.9,  "W14x26",  "W"],
  "W14X30":  [30,  13.8,  "W14x30",  "W"], "W14X34":  [34,  14.0,  "W14x34",  "W"],
  "W14X38":  [38,  14.1,  "W14x38",  "W"], "W14X43":  [43,  13.7,  "W14x43",  "W"],
  "W14X48":  [48,  13.8,  "W14x48",  "W"], "W14X53":  [53,  13.9,  "W14x53",  "W"],
  "W14X61":  [61,  13.9,  "W14x61",  "W"], "W14X68":  [68,  14.0,  "W14x68",  "W"],
  "W14X74":  [74,  14.2,  "W14x74",  "W"], "W14X82":  [82,  14.3,  "W14x82",  "W"],
  "W14X90":  [90,  14.0,  "W14x90",  "W"], "W14X99":  [99,  14.2,  "W14x99",  "W"],
  "W14X109": [109, 14.3,  "W14x109", "W"], "W14X120": [120, 14.5,  "W14x120", "W"],
  "W14X132": [132, 14.7,  "W14x132", "W"], "W14X145": [145, 14.8,  "W14x145", "W"],
  "W14X159": [159, 15.0,  "W14x159", "W"], "W14X176": [176, 15.2,  "W14x176", "W"],
  "W14X193": [193, 15.5,  "W14x193", "W"], "W14X211": [211, 15.7,  "W14x211", "W"],
  "W14X233": [233, 16.0,  "W14x233", "W"], "W14X257": [257, 16.4,  "W14x257", "W"],
  "W14X283": [283, 16.7,  "W14x283", "W"], "W14X311": [311, 17.1,  "W14x311", "W"],
  "W14X342": [342, 17.5,  "W14x342", "W"], "W14X370": [370, 17.9,  "W14x370", "W"],
  "W14X398": [398, 18.3,  "W14x398", "W"], "W14X426": [426, 18.7,  "W14x426", "W"],
  "W14X455": [455, 19.0,  "W14x455", "W"], "W14X500": [500, 19.6,  "W14x500", "W"],
  "W14X550": [550, 20.2,  "W14x550", "W"], "W14X605": [605, 20.9,  "W14x605", "W"],
  "W14X665": [665, 21.6,  "W14x665", "W"], "W14X730": [730, 22.4,  "W14x730", "W"],
  "W16X26":  [26,  15.7,  "W16x26",  "W"], "W16X31":  [31,  15.9,  "W16x31",  "W"],
  "W16X36":  [36,  15.9,  "W16x36",  "W"], "W16X40":  [40,  16.0,  "W16x40",  "W"],
  "W16X45":  [45,  16.1,  "W16x45",  "W"], "W16X50":  [50,  16.3,  "W16x50",  "W"],
  "W16X57":  [57,  16.4,  "W16x57",  "W"], "W16X67":  [67,  16.3,  "W16x67",  "W"],
  "W16X77":  [77,  16.5,  "W16x77",  "W"], "W16X89":  [89,  16.8,  "W16x89",  "W"],
  "W16X100": [100, 17.0,  "W16x100", "W"],
  "W18X35":  [35,  17.7,  "W18x35",  "W"], "W18X40":  [40,  17.9,  "W18x40",  "W"],
  "W18X46":  [46,  18.1,  "W18x46",  "W"], "W18X50":  [50,  18.0,  "W18x50",  "W"],
  "W18X55":  [55,  18.1,  "W18x55",  "W"], "W18X60":  [60,  18.2,  "W18x60",  "W"],
  "W18X65":  [65,  18.4,  "W18x65",  "W"], "W18X71":  [71,  18.5,  "W18x71",  "W"],
  "W18X76":  [76,  18.2,  "W18x76",  "W"], "W18X86":  [86,  18.4,  "W18x86",  "W"],
  "W18X97":  [97,  18.6,  "W18x97",  "W"], "W18X106": [106, 18.7,  "W18x106", "W"],
  "W18X119": [119, 19.0,  "W18x119", "W"], "W18X130": [130, 19.3,  "W18x130", "W"],
  "W18X143": [143, 19.5,  "W18x143", "W"], "W18X158": [158, 19.7,  "W18x158", "W"],
  "W18X175": [175, 20.0,  "W18x175", "W"], "W18X192": [192, 20.4,  "W18x192", "W"],
  "W18X211": [211, 20.7,  "W18x211", "W"], "W18X234": [234, 21.1,  "W18x234", "W"],
  "W18X258": [258, 21.5,  "W18x258", "W"], "W18X283": [283, 21.8,  "W18x283", "W"],
  "W18X311": [311, 22.3,  "W18x311", "W"],
  "W21X44":  [44,  20.7,  "W21x44",  "W"], "W21X48":  [48,  20.6,  "W21x48",  "W"],
  "W21X50":  [50,  20.8,  "W21x50",  "W"], "W21X57":  [57,  21.1,  "W21x57",  "W"],
  "W21X62":  [62,  21.0,  "W21x62",  "W"], "W21X68":  [68,  21.1,  "W21x68",  "W"],
  "W21X73":  [73,  21.2,  "W21x73",  "W"], "W21X83":  [83,  21.4,  "W21x83",  "W"],
  "W21X93":  [93,  21.6,  "W21x93",  "W"], "W21X101": [101, 21.4,  "W21x101", "W"],
  "W21X111": [111, 21.5,  "W21x111", "W"], "W21X122": [122, 21.7,  "W21x122", "W"],
  "W21X132": [132, 21.8,  "W21x132", "W"], "W21X147": [147, 22.1,  "W21x147", "W"],
  "W21X166": [166, 22.5,  "W21x166", "W"], "W21X182": [182, 22.7,  "W21x182", "W"],
  "W21X201": [201, 23.0,  "W21x201", "W"], "W21X223": [223, 23.4,  "W21x223", "W"],
  "W21X248": [248, 23.7,  "W21x248", "W"], "W21X275": [275, 24.1,  "W21x275", "W"],
  "W24X55":  [55,  23.6,  "W24x55",  "W"], "W24X62":  [62,  23.7,  "W24x62",  "W"],
  "W24X68":  [68,  23.7,  "W24x68",  "W"], "W24X76":  [76,  23.9,  "W24x76",  "W"],
  "W24X84":  [84,  24.1,  "W24x84",  "W"], "W24X94":  [94,  24.3,  "W24x94",  "W"],
  "W24X103": [103, 24.5,  "W24x103", "W"], "W24X104": [104, 24.1,  "W24x104", "W"],
  "W24X117": [117, 24.3,  "W24x117", "W"], "W24X131": [131, 24.5,  "W24x131", "W"],
  "W24X146": [146, 24.7,  "W24x146", "W"], "W24X162": [162, 25.0,  "W24x162", "W"],
  "W24X176": [176, 25.2,  "W24x176", "W"], "W24X192": [192, 25.5,  "W24x192", "W"],
  "W24X207": [207, 25.7,  "W24x207", "W"], "W24X229": [229, 26.0,  "W24x229", "W"],
  "W24X250": [250, 26.3,  "W24x250", "W"], "W24X279": [279, 26.7,  "W24x279", "W"],
  "W24X306": [306, 27.1,  "W24x306", "W"], "W24X335": [335, 27.5,  "W24x335", "W"],
  "W27X84":  [84,  26.7,  "W27x84",  "W"], "W27X94":  [94,  26.9,  "W27x94",  "W"],
  "W27X102": [102, 27.1,  "W27x102", "W"], "W27X114": [114, 27.3,  "W27x114", "W"],
  "W27X129": [129, 27.6,  "W27x129", "W"], "W27X146": [146, 27.4,  "W27x146", "W"],
  "W27X161": [161, 27.6,  "W27x161", "W"], "W27X178": [178, 27.8,  "W27x178", "W"],
  "W27X194": [194, 28.1,  "W27x194", "W"], "W27X217": [217, 28.4,  "W27x217", "W"],
  "W27X235": [235, 28.7,  "W27x235", "W"], "W27X258": [258, 29.1,  "W27x258", "W"],
  "W27X281": [281, 29.5,  "W27x281", "W"], "W27X307": [307, 29.9,  "W27x307", "W"],
  "W27X336": [336, 30.4,  "W27x336", "W"], "W27X368": [368, 30.8,  "W27x368", "W"],
  "W30X90":  [90,  29.5,  "W30x90",  "W"], "W30X99":  [99,  29.7,  "W30x99",  "W"],
  "W30X108": [108, 29.8,  "W30x108", "W"], "W30X116": [116, 30.0,  "W30x116", "W"],
  "W30X124": [124, 30.2,  "W30x124", "W"], "W30X132": [132, 30.3,  "W30x132", "W"],
  "W30X148": [148, 30.7,  "W30x148", "W"], "W30X173": [173, 30.4,  "W30x173", "W"],
  "W30X191": [191, 30.7,  "W30x191", "W"], "W30X211": [211, 30.9,  "W30x211", "W"],
  "W30X235": [235, 31.3,  "W30x235", "W"], "W30X261": [261, 31.6,  "W30x261", "W"],
  "W30X292": [292, 32.0,  "W30x292", "W"], "W30X326": [326, 32.4,  "W30x326", "W"],
  "W33X118": [118, 32.9,  "W33x118", "W"], "W33X130": [130, 33.1,  "W33x130", "W"],
  "W33X141": [141, 33.3,  "W33x141", "W"], "W33X152": [152, 33.5,  "W33x152", "W"],
  "W33X169": [169, 33.8,  "W33x169", "W"], "W33X201": [201, 33.7,  "W33x201", "W"],
  "W33X221": [221, 33.9,  "W33x221", "W"], "W33X241": [241, 34.2,  "W33x241", "W"],
  "W33X263": [263, 34.5,  "W33x263", "W"], "W33X291": [291, 34.8,  "W33x291", "W"],
  "W33X318": [318, 35.2,  "W33x318", "W"], "W33X354": [354, 35.6,  "W33x354", "W"],
  "W36X135": [135, 35.6,  "W36x135", "W"], "W36X150": [150, 35.9,  "W36x150", "W"],
  "W36X160": [160, 36.0,  "W36x160", "W"], "W36X170": [170, 36.2,  "W36x170", "W"],
  "W36X182": [182, 36.3,  "W36x182", "W"], "W36X194": [194, 36.5,  "W36x194", "W"],
  "W36X210": [210, 36.7,  "W36x210", "W"], "W36X232": [232, 37.1,  "W36x232", "W"],
  "W36X245": [245, 36.7,  "W36x245", "W"], "W36X256": [256, 37.0,  "W36x256", "W"],
  "W36X280": [280, 37.3,  "W36x280", "W"], "W36X300": [300, 37.7,  "W36x300", "W"],
  "W36X328": [328, 38.0,  "W36x328", "W"], "W36X359": [359, 38.4,  "W36x359", "W"],
  "W36X393": [393, 38.9,  "W36x393", "W"], "W36X439": [439, 39.6,  "W36x439", "W"],
  "W36X487": [487, 40.3,  "W36x487", "W"], "W36X529": [529, 40.9,  "W36x529", "W"],
  "W36X588": [588, 41.7,  "W36x588", "W"], "W36X650": [650, 42.5,  "W36x650", "W"],
  "W36X723": [723, 43.3,  "W36x723", "W"],
  "W40X149": [149, 38.2,  "W40x149", "W"], "W40X167": [167, 38.6,  "W40x167", "W"],
  "W40X183": [183, 39.0,  "W40x183", "W"], "W40X199": [199, 38.7,  "W40x199", "W"],
  "W40X211": [211, 38.7,  "W40x211", "W"], "W40X215": [215, 39.4,  "W40x215", "W"],
  "W40X235": [235, 38.8,  "W40x235", "W"], "W40X249": [249, 39.0,  "W40x249", "W"],
  "W40X264": [264, 39.2,  "W40x264", "W"], "W40X277": [277, 39.7,  "W40x277", "W"],
  "W40X297": [297, 39.8,  "W40x297", "W"], "W40X324": [324, 40.2,  "W40x324", "W"],
  "W40X327": [327, 40.8,  "W40x327", "W"], "W40X362": [362, 40.6,  "W40x362", "W"],
  "W40X372": [372, 41.0,  "W40x372", "W"], "W40X392": [392, 41.0,  "W40x392", "W"],
  "W40X397": [397, 41.8,  "W40x397", "W"], "W40X431": [431, 42.2,  "W40x431", "W"],
  "W40X503": [503, 43.2,  "W40x503", "W"], "W40X593": [593, 44.4,  "W40x593", "W"],
  "W44X198": [198, 43.6,  "W44x198", "W"], "W44X224": [224, 44.0,  "W44x224", "W"],
  "W44X230": [230, 44.0,  "W44x230", "W"], "W44X262": [262, 44.4,  "W44x262", "W"],
  "W44X285": [285, 44.8,  "W44x285", "W"], "W44X290": [290, 44.7,  "W44x290", "W"],
  "W44X335": [335, 45.4,  "W44x335", "W"],

  // ══ S SHAPES ══════════════════════════════════════════════════════════════
  "S3X5.7":   [5.7,   3.00, "S3x5.7",   "S"], "S3X7.5":   [7.5,   3.00, "S3x7.5",   "S"],
  "S4X7.7":   [7.7,   4.00, "S4x7.7",   "S"], "S4X9.5":   [9.5,   4.00, "S4x9.5",   "S"],
  "S5X10":    [10,    5.00, "S5x10",    "S"], "S5X14.75": [14.75, 5.00, "S5x14.75", "S"],
  "S6X12.5":  [12.5,  6.00, "S6x12.5",  "S"], "S6X17.25": [17.25, 6.00, "S6x17.25", "S"],
  "S7X15.3":  [15.3,  7.00, "S7x15.3",  "S"], "S7X20":    [20,    7.00, "S7x20",    "S"],
  "S8X18.4":  [18.4,  8.00, "S8x18.4",  "S"], "S8X23":    [23,    8.00, "S8x23",    "S"],
  "S10X25.4": [25.4, 10.00, "S10x25.4", "S"], "S10X35":   [35,   10.00, "S10x35",   "S"],
  "S12X31.8": [31.8, 12.00, "S12x31.8", "S"], "S12X35":   [35,   12.00, "S12x35",   "S"],
  "S12X40.8": [40.8, 12.00, "S12x40.8", "S"], "S12X50":   [50,   12.00, "S12x50",   "S"],
  "S15X42.9": [42.9, 15.00, "S15x42.9", "S"], "S15X50":   [50,   15.00, "S15x50",   "S"],
  "S18X54.7": [54.7, 18.00, "S18x54.7", "S"], "S18X70":   [70,   18.00, "S18x70",   "S"],
  "S20X66":   [66,   20.00, "S20x66",   "S"], "S20X75":   [75,   20.00, "S20x75",   "S"],
  "S20X86":   [86,   20.00, "S20x86",   "S"], "S20X96":   [96,   20.00, "S20x96",   "S"],
  "S24X80":   [80,   24.00, "S24x80",   "S"], "S24X100":  [100,  24.00, "S24x100",  "S"],
  "S24X106":  [106,  24.00, "S24x106",  "S"], "S24X121":  [121,  24.00, "S24x121",  "S"],

  // ══ M SHAPES ══════════════════════════════════════════════════════════════
  "M3X2.9":  [2.9,   3.00, "M3x2.9",  "M"], "M4X4.08": [4.08,  4.00, "M4x4.08", "M"],
  "M4X6":    [6,     4.00, "M4x6",    "M"], "M5X18.9": [18.9,  5.00, "M5x18.9", "M"],
  "M6X3.7":  [3.7,   6.00, "M6x3.7",  "M"], "M6X4.4":  [4.4,   6.00, "M6x4.4",  "M"],
  "M6X20":   [20,    6.00, "M6x20",   "M"], "M8X6.5":  [6.5,   8.00, "M8x6.5",  "M"],
  "M10X7.5": [7.5,  10.00, "M10x7.5", "M"], "M10X8":   [8,    10.00, "M10x8",   "M"],
  "M10X9":   [9,    10.00, "M10x9",   "M"], "M12X10":  [10,   12.00, "M12x10",  "M"],
  "M12X11.8":[11.8, 12.00, "M12x11.8","M"],

  // ══ HP SHAPES ═════════════════════════════════════════════════════════════
  "HP8X36":   [36,   8.02, "HP8x36",   "HP"], "HP10X42":  [42,   9.70, "HP10x42",  "HP"],
  "HP10X57":  [57,   9.99, "HP10x57",  "HP"], "HP12X53":  [53,  11.8,  "HP12x53",  "HP"],
  "HP12X63":  [63,  12.0,  "HP12x63",  "HP"], "HP12X74":  [74,  12.1,  "HP12x74",  "HP"],
  "HP12X84":  [84,  12.3,  "HP12x84",  "HP"], "HP14X73":  [73,  13.6,  "HP14x73",  "HP"],
  "HP14X89":  [89,  13.8,  "HP14x89",  "HP"], "HP14X102": [102, 14.0,  "HP14x102", "HP"],
  "HP14X117": [117, 14.2,  "HP14x117", "HP"], "HP16X88":  [88,  15.8,  "HP16x88",  "HP"],
  "HP16X101": [101, 16.0,  "HP16x101", "HP"], "HP16X121": [121, 16.2,  "HP16x121", "HP"],
  "HP18X135": [135, 17.7,  "HP18x135", "HP"], "HP18X157": [157, 18.0,  "HP18x157", "HP"],
  "HP18X181": [181, 18.3,  "HP18x181", "HP"], "HP18X204": [204, 18.6,  "HP18x204", "HP"],

  // ══ C SHAPES (American Standard Channels) ═════════════════════════════════
  "C3X3.5":  [3.5,  3.00, "C3x3.5",  "C"], "C3X4.1":  [4.1,  3.00, "C3x4.1",  "C"],
  "C3X5":    [5,    3.00, "C3x5",    "C"], "C3X6":    [6,    3.00, "C3x6",    "C"],
  "C4X4.5":  [4.5,  4.00, "C4x4.5",  "C"], "C4X5.4":  [5.4,  4.00, "C4x5.4",  "C"],
  "C4X7.25": [7.25, 4.00, "C4x7.25", "C"],
  "C5X6.7":  [6.7,  5.00, "C5x6.7",  "C"], "C5X9":    [9,    5.00, "C5x9",    "C"],
  "C6X8.2":  [8.2,  6.00, "C6x8.2",  "C"], "C6X10.5": [10.5, 6.00, "C6x10.5", "C"],
  "C6X13":   [13,   6.00, "C6x13",   "C"],
  "C7X9.8":  [9.8,  7.00, "C7x9.8",  "C"], "C7X12.25":[12.25,7.00, "C7x12.25","C"],
  "C7X14.75":[14.75,7.00, "C7x14.75","C"],
  "C8X11.5": [11.5, 8.00, "C8x11.5", "C"], "C8X13.75":[13.75,8.00, "C8x13.75","C"],
  "C8X18.75":[18.75,8.00, "C8x18.75","C"],
  "C9X13.4": [13.4, 9.00, "C9x13.4", "C"], "C9X15":   [15,   9.00, "C9x15",   "C"],
  "C9X20":   [20,   9.00, "C9x20",   "C"],
  "C10X15.3":[15.3,10.00, "C10x15.3","C"], "C10X20":  [20,  10.00, "C10x20",  "C"],
  "C10X25":  [25,  10.00, "C10x25",  "C"], "C10X30":  [30,  10.00, "C10x30",  "C"],
  "C12X20.7":[20.7,12.00, "C12x20.7","C"], "C12X25":  [25,  12.00, "C12x25",  "C"],
  "C12X30":  [30,  12.00, "C12x30",  "C"],
  "C15X33.9":[33.9,15.00, "C15x33.9","C"], "C15X40":  [40,  15.00, "C15x40",  "C"],
  "C15X50":  [50,  15.00, "C15x50",  "C"],

  // ══ MC SHAPES (Misc Channels) ══════════════════════════════════════════════
  "MC3X7.1":  [7.1,  3.00, "MC3x7.1",  "MC"], "MC4X13.8": [13.8, 4.00, "MC4x13.8", "MC"],
  "MC6X12":   [12,   6.00, "MC6x12",   "MC"], "MC6X15.1": [15.1, 6.00, "MC6x15.1", "MC"],
  "MC6X16.3": [16.3, 6.00, "MC6x16.3", "MC"], "MC6X18":   [18,   6.00, "MC6x18",   "MC"],
  "MC7X19.1": [19.1, 7.00, "MC7x19.1", "MC"], "MC7X22.7": [22.7, 7.00, "MC7x22.7", "MC"],
  "MC8X18.7": [18.7, 8.00, "MC8x18.7", "MC"], "MC8X20":   [20,   8.00, "MC8x20",   "MC"],
  "MC8X21.4": [21.4, 8.00, "MC8x21.4", "MC"], "MC8X22.8": [22.8, 8.00, "MC8x22.8", "MC"],
  "MC9X23.9": [23.9, 9.00, "MC9x23.9", "MC"], "MC9X25.4": [25.4, 9.00, "MC9x25.4", "MC"],
  "MC10X22":  [22,  10.00, "MC10x22",  "MC"], "MC10X25":  [25,  10.00, "MC10x25",  "MC"],
  "MC10X28.5":[28.5,10.00, "MC10x28.5","MC"], "MC10X33.6":[33.6,10.00, "MC10x33.6","MC"],
  "MC12X10.6":[10.6,12.00, "MC12x10.6","MC"], "MC12X31":  [31,  12.00, "MC12x31",  "MC"],
  "MC12X35":  [35,  12.00, "MC12x35",  "MC"], "MC12X40":  [40,  12.00, "MC12x40",  "MC"],
  "MC12X45":  [45,  12.00, "MC12x45",  "MC"], "MC13X31.8":[31.8,13.00, "MC13x31.8","MC"],
  "MC13X35":  [35,  13.00, "MC13x35",  "MC"], "MC13X40":  [40,  13.00, "MC13x40",  "MC"],
  "MC13X50":  [50,  13.00, "MC13x50",  "MC"], "MC18X42.7":[42.7,18.00, "MC18x42.7","MC"],
  "MC18X51.9":[51.9,18.00, "MC18x51.9","MC"], "MC18X58":  [58,  18.00, "MC18x58",  "MC"],

  // ══ L SHAPES (Equal Legs) ══════════════════════════════════════════════════
  "L2X2X1/8":   [0.80, 2.00, "L2x2x1/8",   "L"], "L2X2X3/16":  [1.16, 2.00, "L2x2x3/16",  "L"],
  "L2X2X1/4":   [1.65, 2.00, "L2x2x1/4",   "L"], "L2X2X5/16":  [1.92, 2.00, "L2x2x5/16",  "L"],
  "L2X2X3/8":   [2.44, 2.00, "L2x2x3/8",   "L"],
  "L2.5X2.5X3/16":[1.46,2.50,"L2.5x2.5x3/16","L"],"L2.5X2.5X1/4": [1.92,2.50, "L2.5x2.5x1/4","L"],
  "L2.5X2.5X5/16":[2.44,2.50,"L2.5x2.5x5/16","L"],"L2.5X2.5X3/8": [2.75,2.50, "L2.5x2.5x3/8","L"],
  "L3X3X1/4":   [2.77, 3.00, "L3x3x1/4",   "L"], "L3X3X5/16":  [3.71, 3.00, "L3x3x5/16",  "L"],
  "L3X3X3/8":   [4.90, 3.00, "L3x3x3/8",   "L"], "L3X3X1/2":   [5.80, 3.00, "L3x3x1/2",   "L"],
  "L3.5X3.5X1/4":[3.19,3.50,"L3.5x3.5x1/4","L"],"L3.5X3.5X5/16":[4.30,3.50,"L3.5x3.5x5/16","L"],
  "L3.5X3.5X3/8":[5.40,3.50,"L3.5x3.5x3/8","L"],"L3.5X3.5X1/2": [6.60,3.50,"L3.5x3.5x1/2","L"],
  "L4X4X1/4":   [3.65, 4.00, "L4x4x1/4",   "L"], "L4X4X5/16":  [4.70, 4.00, "L4x4x5/16",  "L"],
  "L4X4X3/8":   [6.20, 4.00, "L4x4x3/8",   "L"], "L4X4X1/2":   [8.20, 4.00, "L4x4x1/2",   "L"],
  "L4X4X5/8":   [9.80, 4.00, "L4x4x5/8",   "L"], "L4X4X3/4":   [11.3, 4.00, "L4x4x3/4",   "L"],
  "L5X5X5/16":  [5.90, 5.00, "L5x5x5/16",  "L"], "L5X5X3/8":   [7.70, 5.00, "L5x5x3/8",   "L"],
  "L5X5X1/2":   [10.3, 5.00, "L5x5x1/2",   "L"], "L5X5X5/8":   [12.3, 5.00, "L5x5x5/8",   "L"],
  "L5X5X3/4":   [14.3, 5.00, "L5x5x3/4",   "L"],
  "L6X6X3/8":   [9.40, 6.00, "L6x6x3/8",   "L"], "L6X6X7/16":  [11.7, 6.00, "L6x6x7/16",  "L"],
  "L6X6X1/2":   [12.4, 6.00, "L6x6x1/2",   "L"], "L6X6X9/16":  [14.3, 6.00, "L6x6x9/16",  "L"],
  "L6X6X5/8":   [14.9, 6.00, "L6x6x5/8",   "L"], "L6X6X3/4":   [19.6, 6.00, "L6x6x3/4",   "L"],
  "L6X6X1":     [24.2, 6.00, "L6x6x1",     "L"],
  "L8X8X1/2":   [16.8, 8.00, "L8x8x1/2",   "L"], "L8X8X9/16":  [18.5, 8.00, "L8x8x9/16",  "L"],
  "L8X8X5/8":   [20.2, 8.00, "L8x8x5/8",   "L"], "L8X8X3/4":   [26.4, 8.00, "L8x8x3/4",   "L"],
  "L8X8X1":     [34.9, 8.00, "L8x8x1",     "L"], "L8X8X1.125": [38.9, 8.00, "L8x8x1-1/8", "L"],

  // ══ WT SHAPES (Structural Tees from W) ════════════════════════════════════
  "WT2X6.5":  [6.5,  2.08, "WT2x6.5",  "WT"], "WT3X7.5":  [7.5,  3.00, "WT3x7.5",  "WT"],
  "WT4X9":    [9,    4.00, "WT4x9",    "WT"], "WT4X10.5": [10.5, 4.00, "WT4x10.5", "WT"],
  "WT5X6":    [6,    5.00, "WT5x6",    "WT"], "WT5X7.5":  [7.5,  5.00, "WT5x7.5",  "WT"],
  "WT5X9":    [9,    5.00, "WT5x9",    "WT"], "WT5X11":   [11,   5.00, "WT5x11",   "WT"],
  "WT5X13":   [13,   5.00, "WT5x13",   "WT"], "WT5X15":   [15,   5.00, "WT5x15",   "WT"],
  "WT5X16.5": [16.5, 5.00, "WT5x16.5", "WT"], "WT5X19.5": [19.5, 5.00, "WT5x19.5", "WT"],
  "WT5X22.5": [22.5, 5.00, "WT5x22.5", "WT"], "WT5X25":   [25,   5.00, "WT5x25",   "WT"],
  "WT5X27.5": [27.5, 5.00, "WT5x27.5", "WT"],
  "WT6X7":    [7,    6.00, "WT6x7",    "WT"], "WT6X8":    [8,    6.00, "WT6x8",    "WT"],
  "WT6X9.5":  [9.5,  6.00, "WT6x9.5",  "WT"], "WT6X10.5": [10.5, 6.00, "WT6x10.5", "WT"],
  "WT6X11":   [11,   6.00, "WT6x11",   "WT"], "WT6X13":   [13,   6.00, "WT6x13",   "WT"],
  "WT6X15":   [15,   6.00, "WT6x15",   "WT"], "WT6X17.5": [17.5, 6.14, "WT6x17.5", "WT"],
  "WT6X20":   [20,   6.16, "WT6x20",   "WT"], "WT6X22.5": [22.5, 6.19, "WT6x22.5", "WT"],
  "WT6X25":   [25,   6.22, "WT6x25",   "WT"], "WT6X26.5": [26.5, 6.15, "WT6x26.5", "WT"],
  "WT6X29":   [29,   6.19, "WT6x29",   "WT"], "WT6X32.5": [32.5, 6.25, "WT6x32.5", "WT"],
  "WT6X36":   [36,   6.31, "WT6x36",   "WT"], "WT6X39.5": [39.5, 6.35, "WT6x39.5", "WT"],
  "WT6X43.5": [43.5, 6.41, "WT6x43.5", "WT"], "WT6X48":   [48,   6.50, "WT6x48",   "WT"],
  "WT7X11":   [11,   6.92, "WT7x11",   "WT"], "WT7X13":   [13,   7.00, "WT7x13",   "WT"],
  "WT7X15":   [15,   7.04, "WT7x15",   "WT"], "WT7X17":   [17,   7.06, "WT7x17",   "WT"],
  "WT7X19":   [19,   7.05, "WT7x19",   "WT"], "WT7X21.5": [21.5, 7.09, "WT7x21.5", "WT"],
  "WT7X24":   [24,   7.14, "WT7x24",   "WT"], "WT7X26.5": [26.5, 7.00, "WT7x26.5", "WT"],
  "WT7X30.5": [30.5, 7.08, "WT7x30.5", "WT"], "WT7X34":   [34,   7.02, "WT7x34",   "WT"],
  "WT7X37":   [37,   7.09, "WT7x37",   "WT"], "WT7X41":   [41,   7.16, "WT7x41",   "WT"],
  "WT7X45":   [45,   7.22, "WT7x45",   "WT"], "WT7X49.5": [49.5, 7.29, "WT7x49.5", "WT"],
  "WT7X54.5": [54.5, 7.39, "WT7x54.5", "WT"], "WT7X60":   [60,   7.50, "WT7x60",   "WT"],
  "WT7X66":   [66,   7.60, "WT7x66",   "WT"], "WT7X72.5": [72.5, 7.72, "WT7x72.5", "WT"],
  "WT7X79":   [79,   7.83, "WT7x79",   "WT"], "WT7X85":   [85,   7.94, "WT7x85",   "WT"],
  "WT8X13":   [13,   8.01, "WT8x13",   "WT"], "WT8X15.5": [15.5, 8.01, "WT8x15.5", "WT"],
  "WT8X18":   [18,   8.00, "WT8x18",   "WT"], "WT8X20":   [20,   8.01, "WT8x20",   "WT"],
  "WT8X22.5": [22.5, 8.06, "WT8x22.5", "WT"], "WT8X25":   [25,   8.13, "WT8x25",   "WT"],
  "WT8X28.5": [28.5, 8.02, "WT8x28.5", "WT"], "WT8X33.5": [33.5, 8.17, "WT8x33.5", "WT"],
  "WT8X38.5": [38.5, 8.26, "WT8x38.5", "WT"], "WT8X44.5": [44.5, 8.37, "WT8x44.5", "WT"],
  "WT9X20":   [20,   9.00, "WT9x20",   "WT"], "WT9X23":   [23,   9.01, "WT9x23",   "WT"],
  "WT9X25":   [25,   8.99, "WT9x25",   "WT"], "WT9X27.5": [27.5, 9.02, "WT9x27.5", "WT"],
  "WT9X30":   [30,   9.12, "WT9x30",   "WT"], "WT9X35.5": [35.5, 9.16, "WT9x35.5", "WT"],
  "WT9X38":   [38,   9.02, "WT9x38",   "WT"], "WT9X43":   [43,   9.15, "WT9x43",   "WT"],
  "WT9X48.5": [48.5, 9.29, "WT9x48.5", "WT"], "WT9X53":   [53,   9.37, "WT9x53",   "WT"],
  "WT10X28":  [28,  10.0,  "WT10x28",  "WT"], "WT10X31":  [31,  10.0,  "WT10x31",  "WT"],
  "WT10X34":  [34,  10.1,  "WT10x34",  "WT"], "WT10X38.5":[38.5,10.1,  "WT10x38.5","WT"],
  "WT10X43":  [43,  10.2,  "WT10x43",  "WT"], "WT10X48.5":[48.5,10.2,  "WT10x48.5","WT"],
  "WT10X60":  [60,  10.2,  "WT10x60",  "WT"], "WT10X68":  [68,  10.3,  "WT10x68",  "WT"],
  "WT10X100": [100, 10.7,  "WT10x100", "WT"],
  "WT12X34":  [34,  11.9,  "WT12x34",  "WT"], "WT12X38":  [38,  12.0,  "WT12x38",  "WT"],
  "WT12X42":  [42,  12.1,  "WT12x42",  "WT"], "WT12X47":  [47,  12.2,  "WT12x47",  "WT"],
  "WT12X51.5":[51.5,12.1,  "WT12x51.5","WT"], "WT12X58":  [58,  12.2,  "WT12x58",  "WT"],
  "WT12X65.5":[65.5,12.1,  "WT12x65.5","WT"], "WT12X72":  [72,  12.3,  "WT12x72",  "WT"],
  "WT12X81":  [81,  12.5,  "WT12x81",  "WT"],

  // ══ ST SHAPES (Structural Tees from S) ═══════════════════════════════════
  "ST1.5X2.85": [2.85,  1.50, "ST1.5x2.85", "ST"], "ST1.5X3.75": [3.75,  1.50, "ST1.5x3.75", "ST"],
  "ST2X3.85":   [3.85,  2.00, "ST2x3.85",   "ST"], "ST2X4.75":   [4.75,  2.00, "ST2x4.75",   "ST"],
  "ST2.5X5":    [5,     2.50, "ST2.5x5",    "ST"], "ST2.5X7.375":[7.375, 2.50, "ST2.5x7.375","ST"],
  "ST3X6.25":   [6.25,  3.00, "ST3x6.25",   "ST"], "ST3X8.625":  [8.625, 3.00, "ST3x8.625",  "ST"],
  "ST4X9.2":    [9.2,   4.00, "ST4x9.2",    "ST"], "ST4X11.5":   [11.5,  4.00, "ST4x11.5",   "ST"],
  "ST5X12.7":   [12.7,  5.00, "ST5x12.7",   "ST"], "ST5X17.5":   [17.5,  5.00, "ST5x17.5",   "ST"],
  "ST6X15.9":   [15.9,  6.00, "ST6x15.9",   "ST"], "ST6X20.4":   [20.4,  6.00, "ST6x20.4",   "ST"],
  "ST6X25":     [25,    6.00, "ST6x25",     "ST"],
  "ST7.5X21.45":[21.45, 7.50, "ST7.5x21.45","ST"], "ST7.5X25":   [25,    7.50, "ST7.5x25",   "ST"],
  "ST9X27.35":  [27.35, 9.00, "ST9x27.35",  "ST"], "ST9X35":     [35,    9.00, "ST9x35",     "ST"],
  "ST10X33":    [33,   10.00, "ST10x33",    "ST"], "ST10X37.5":  [37.5, 10.00, "ST10x37.5",  "ST"],
  "ST10X43":    [43,   10.00, "ST10x43",    "ST"], "ST10X48":    [48,   10.00, "ST10x48",    "ST"],
  "ST12X40.25": [40.25,12.00, "ST12x40.25", "ST"], "ST12X50":    [50,   12.00, "ST12x50",    "ST"],
  "ST12X60.5":  [60.5, 12.00, "ST12x60.5",  "ST"],

  // ══ MT SHAPES ══════════════════════════════════════════════════════════════
  "MT2X3":    [3,    2.00, "MT2x3",    "MT"], "MT3X2.2":  [2.2,  3.00, "MT3x2.2",  "MT"],
  "MT4X3.25": [3.25, 4.00, "MT4x3.25", "MT"], "MT5X3.75": [3.75, 5.00, "MT5x3.75", "MT"],
  "MT6X5":    [5,    6.00, "MT6x5",    "MT"], "MT6X5.4":  [5.4,  6.00, "MT6x5.4",  "MT"],
  "MT6X5.9":  [5.9,  6.00, "MT6x5.9",  "MT"],

  // ══ HSS RECTANGULAR / SQUARE ══════════════════════════════════════════════
  "HSS2X2X1/4":    [3.65, 2.00, "HSS2x2x1/4",    "HSS"], "HSS2X2X3/16":  [2.91, 2.00, "HSS2x2x3/16",  "HSS"],
  "HSS2X2X1/8":    [1.84, 2.00, "HSS2x2x1/8",    "HSS"],
  "HSS3X3X1/4":    [5.59, 3.00, "HSS3x3x1/4",    "HSS"], "HSS3X3X3/16":  [4.51, 3.00, "HSS3x3x3/16",  "HSS"],
  "HSS3X3X1/8":    [3.05, 3.00, "HSS3x3x1/8",    "HSS"],
  "HSS4X4X1/2":    [13.1, 4.00, "HSS4x4x1/2",    "HSS"], "HSS4X4X3/8":   [10.3, 4.00, "HSS4x4x3/8",   "HSS"],
  "HSS4X4X5/16":   [8.81, 4.00, "HSS4x4x5/16",   "HSS"], "HSS4X4X1/4":   [7.31, 4.00, "HSS4x4x1/4",   "HSS"],
  "HSS4X4X3/16":   [5.59, 4.00, "HSS4x4x3/16",   "HSS"], "HSS4X4X1/8":   [3.83, 4.00, "HSS4x4x1/8",   "HSS"],
  "HSS5X5X1/2":    [16.8, 5.00, "HSS5x5x1/2",    "HSS"], "HSS5X5X3/8":   [13.3, 5.00, "HSS5x5x3/8",   "HSS"],
  "HSS5X5X5/16":   [11.3, 5.00, "HSS5x5x5/16",   "HSS"], "HSS5X5X1/4":   [9.36, 5.00, "HSS5x5x1/4",   "HSS"],
  "HSS5X5X3/16":   [7.11, 5.00, "HSS5x5x3/16",   "HSS"], "HSS5X5X1/8":   [4.85, 5.00, "HSS5x5x1/8",   "HSS"],
  "HSS6X6X5/8":    [27.4, 6.00, "HSS6x6x5/8",    "HSS"], "HSS6X6X1/2":   [22.7, 6.00, "HSS6x6x1/2",   "HSS"],
  "HSS6X6X3/8":    [17.5, 6.00, "HSS6x6x3/8",    "HSS"], "HSS6X6X5/16":  [14.8, 6.00, "HSS6x6x5/16",  "HSS"],
  "HSS6X6X1/4":    [12.2, 6.00, "HSS6x6x1/4",    "HSS"], "HSS6X6X3/16":  [9.30, 6.00, "HSS6x6x3/16",  "HSS"],
  "HSS6X6X1/8":    [6.35, 6.00, "HSS6x6x1/8",    "HSS"],
  "HSS7X7X5/8":    [32.4, 7.00, "HSS7x7x5/8",    "HSS"], "HSS7X7X1/2":   [26.8, 7.00, "HSS7x7x1/2",   "HSS"],
  "HSS7X7X3/8":    [20.8, 7.00, "HSS7x7x3/8",    "HSS"], "HSS7X7X5/16":  [17.6, 7.00, "HSS7x7x5/16",  "HSS"],
  "HSS7X7X1/4":    [14.5, 7.00, "HSS7x7x1/4",    "HSS"], "HSS7X7X3/16":  [11.1, 7.00, "HSS7x7x3/16",  "HSS"],
  "HSS8X8X5/8":    [37.7, 8.00, "HSS8x8x5/8",    "HSS"], "HSS8X8X1/2":   [31.3, 8.00, "HSS8x8x1/2",   "HSS"],
  "HSS8X8X3/8":    [24.3, 8.00, "HSS8x8x3/8",    "HSS"], "HSS8X8X5/16":  [20.6, 8.00, "HSS8x8x5/16",  "HSS"],
  "HSS8X8X1/4":    [17.0, 8.00, "HSS8x8x1/4",    "HSS"], "HSS8X8X3/16":  [12.9, 8.00, "HSS8x8x3/16",  "HSS"],
  "HSS10X10X5/8":  [48.0,10.00, "HSS10x10x5/8",  "HSS"], "HSS10X10X1/2": [39.7,10.00, "HSS10x10x1/2", "HSS"],
  "HSS10X10X3/8":  [31.0,10.00, "HSS10x10x3/8",  "HSS"], "HSS10X10X5/16":[26.3,10.00, "HSS10x10x5/16","HSS"],
  "HSS10X10X1/4":  [21.7,10.00, "HSS10x10x1/4",  "HSS"], "HSS10X10X3/16":[16.5,10.00, "HSS10x10x3/16","HSS"],
  "HSS12X12X5/8":  [58.0,12.00, "HSS12x12x5/8",  "HSS"], "HSS12X12X1/2": [48.1,12.00, "HSS12x12x1/2", "HSS"],
  "HSS12X12X3/8":  [37.6,12.00, "HSS12x12x3/8",  "HSS"], "HSS12X12X5/16":[31.9,12.00, "HSS12x12x5/16","HSS"],
  "HSS12X12X1/4":  [26.4,12.00, "HSS12x12x1/4",  "HSS"],
  "HSS14X14X5/8":  [68.0,14.00, "HSS14x14x5/8",  "HSS"], "HSS14X14X1/2": [56.6,14.00, "HSS14x14x1/2", "HSS"],
  "HSS14X14X3/8":  [44.2,14.00, "HSS14x14x3/8",  "HSS"], "HSS14X14X5/16":[37.5,14.00, "HSS14x14x5/16","HSS"],
  "HSS14X14X1/4":  [31.0,14.00, "HSS14x14x1/4",  "HSS"],
  "HSS16X16X5/8":  [78.5,16.00, "HSS16x16x5/8",  "HSS"], "HSS16X16X1/2": [65.2,16.00, "HSS16x16x1/2", "HSS"],
  "HSS16X16X3/8":  [51.0,16.00, "HSS16x16x3/8",  "HSS"], "HSS16X16X5/16":[43.2,16.00, "HSS16x16x5/16","HSS"],
  "HSS16X16X1/4":  [35.7,16.00, "HSS16x16x1/4",  "HSS"],
  "HSS20X20X5/8":  [99.0,20.00, "HSS20x20x5/8",  "HSS"], "HSS20X20X1/2": [82.3,20.00, "HSS20x20x1/2", "HSS"],
  "HSS20X20X3/8":  [64.4,20.00, "HSS20x20x3/8",  "HSS"],
  // Common rectangular HSS
  "HSS6X4X1/2":    [18.2, 6.00, "HSS6x4x1/2",    "HSS"], "HSS6X4X3/8":   [14.2, 6.00, "HSS6x4x3/8",   "HSS"],
  "HSS6X4X5/16":   [12.1, 6.00, "HSS6x4x5/16",   "HSS"], "HSS6X4X1/4":   [10.0, 6.00, "HSS6x4x1/4",   "HSS"],
  "HSS6X4X3/16":   [7.65, 6.00, "HSS6x4x3/16",   "HSS"],
  "HSS8X4X1/2":    [22.7, 8.00, "HSS8x4x1/2",    "HSS"], "HSS8X4X3/8":   [17.6, 8.00, "HSS8x4x3/8",   "HSS"],
  "HSS8X4X5/16":   [15.0, 8.00, "HSS8x4x5/16",   "HSS"], "HSS8X4X1/4":   [12.4, 8.00, "HSS8x4x1/4",   "HSS"],
  "HSS8X6X1/2":    [27.1, 8.00, "HSS8x6x1/2",    "HSS"], "HSS8X6X3/8":   [21.2, 8.00, "HSS8x6x3/8",   "HSS"],
  "HSS8X6X5/16":   [18.0, 8.00, "HSS8x6x5/16",   "HSS"], "HSS8X6X1/4":   [14.9, 8.00, "HSS8x6x1/4",   "HSS"],
  "HSS10X6X1/2":   [31.6,10.00, "HSS10x6x1/2",   "HSS"], "HSS10X6X3/8":  [24.7,10.00, "HSS10x6x3/8",  "HSS"],
  "HSS10X6X5/16":  [21.0,10.00, "HSS10x6x5/16",  "HSS"], "HSS10X6X1/4":  [17.3,10.00, "HSS10x6x1/4",  "HSS"],
  "HSS12X6X1/2":   [36.0,12.00, "HSS12x6x1/2",   "HSS"], "HSS12X6X3/8":  [28.3,12.00, "HSS12x6x3/8",  "HSS"],
  "HSS12X6X5/16":  [24.0,12.00, "HSS12x6x5/16",  "HSS"], "HSS12X6X1/4":  [19.8,12.00, "HSS12x6x1/4",  "HSS"],
  "HSS12X8X1/2":   [40.4,12.00, "HSS12x8x1/2",   "HSS"], "HSS12X8X3/8":  [31.7,12.00, "HSS12x8x3/8",  "HSS"],
  "HSS12X8X5/16":  [26.9,12.00, "HSS12x8x5/16",  "HSS"], "HSS12X8X1/4":  [22.2,12.00, "HSS12x8x1/4",  "HSS"],

  // ══ HSS ROUND (OD x Wall) ══════════════════════════════════════════════════
  "HSS2.375X0.250":  [5.02,  2.375, "HSS2.375x0.250",  "HSS"], "HSS2.375X0.188": [3.84,  2.375, "HSS2.375x0.188", "HSS"],
  "HSS2.875X0.250":  [6.17,  2.875, "HSS2.875x0.250",  "HSS"], "HSS2.875X0.188": [4.74,  2.875, "HSS2.875x0.188", "HSS"],
  "HSS3.500X0.300":  [9.56,  3.500, "HSS3.500x0.300",  "HSS"], "HSS3.500X0.250": [8.16,  3.500, "HSS3.500x0.250", "HSS"],
  "HSS3.500X0.188":  [6.28,  3.500, "HSS3.500x0.188",  "HSS"],
  "HSS4.000X0.337":  [12.5,  4.000, "HSS4.000x0.337",  "HSS"], "HSS4.000X0.250": [9.42,  4.000, "HSS4.000x0.250", "HSS"],
  "HSS4.000X0.188":  [7.28,  4.000, "HSS4.000x0.188",  "HSS"],
  "HSS4.500X0.337":  [14.2,  4.500, "HSS4.500x0.337",  "HSS"], "HSS4.500X0.250": [10.7,  4.500, "HSS4.500x0.250", "HSS"],
  "HSS5.000X0.375":  [17.9,  5.000, "HSS5.000x0.375",  "HSS"], "HSS5.000X0.312": [15.1,  5.000, "HSS5.000x0.312", "HSS"],
  "HSS5.000X0.250":  [12.3,  5.000, "HSS5.000x0.250",  "HSS"],
  "HSS5.500X0.375":  [19.8,  5.500, "HSS5.500x0.375",  "HSS"], "HSS5.500X0.258": [13.9,  5.500, "HSS5.500x0.258", "HSS"],
  "HSS6.000X0.500":  [28.6,  6.000, "HSS6.000x0.500",  "HSS"], "HSS6.000X0.375": [22.0,  6.000, "HSS6.000x0.375", "HSS"],
  "HSS6.000X0.312":  [18.5,  6.000, "HSS6.000x0.312",  "HSS"], "HSS6.000X0.250": [15.0,  6.000, "HSS6.000x0.250", "HSS"],
  "HSS6.625X0.432":  [27.6,  6.625, "HSS6.625x0.432",  "HSS"], "HSS6.625X0.375": [24.3,  6.625, "HSS6.625x0.375", "HSS"],
  "HSS6.625X0.280":  [18.5,  6.625, "HSS6.625x0.280",  "HSS"],
  "HSS7.000X0.500":  [33.8,  7.000, "HSS7.000x0.500",  "HSS"], "HSS7.000X0.375": [25.8,  7.000, "HSS7.000x0.375", "HSS"],
  "HSS8.000X0.500":  [39.1,  8.000, "HSS8.000x0.500",  "HSS"], "HSS8.000X0.375": [30.0,  8.000, "HSS8.000x0.375", "HSS"],
  "HSS8.000X0.312":  [25.2,  8.000, "HSS8.000x0.312",  "HSS"], "HSS8.000X0.250": [20.4,  8.000, "HSS8.000x0.250", "HSS"],
  "HSS8.625X0.500":  [42.5,  8.625, "HSS8.625x0.500",  "HSS"], "HSS8.625X0.322": [27.9,  8.625, "HSS8.625x0.322", "HSS"],
  "HSS10.000X0.500": [49.3, 10.000, "HSS10.000x0.500", "HSS"], "HSS10.000X0.375":[37.4, 10.000, "HSS10.000x0.375","HSS"],
  "HSS10.000X0.312": [31.4, 10.000, "HSS10.000x0.312", "HSS"], "HSS10.000X0.250":[25.4, 10.000, "HSS10.000x0.250","HSS"],
  "HSS12.000X0.500": [59.4, 12.000, "HSS12.000x0.500", "HSS"], "HSS12.000X0.375":[45.2, 12.000, "HSS12.000x0.375","HSS"],
  "HSS12.000X0.312": [38.0, 12.000, "HSS12.000x0.312", "HSS"],
  "HSS14.000X0.500": [69.6, 14.000, "HSS14.000x0.500", "HSS"], "HSS14.000X0.375":[53.1, 14.000, "HSS14.000x0.375","HSS"],
  "HSS16.000X0.500": [79.9, 16.000, "HSS16.000x0.500", "HSS"], "HSS16.000X0.375":[60.9, 16.000, "HSS16.000x0.375","HSS"],
  "HSS20.000X0.500": [100,  20.000, "HSS20.000x0.500", "HSS"],

  // ══ PIPE ═══════════════════════════════════════════════════════════════════
  "PIPE3STD":    [7.58,  3.500, "Pipe3Std",    "PIPE"], "PIPE3XS":     [10.3,  3.500, "Pipe3XS",     "PIPE"],
  "PIPE3XXS":    [18.6,  3.500, "Pipe3XXS",    "PIPE"],
  "PIPE3.5STD":  [9.11,  4.000, "Pipe3.5Std",  "PIPE"], "PIPE3.5XS":   [12.5,  4.000, "Pipe3.5XS",   "PIPE"],
  "PIPE4STD":    [10.8,  4.500, "Pipe4Std",    "PIPE"], "PIPE4XS":     [15.0,  4.500, "Pipe4XS",     "PIPE"],
  "PIPE4XXS":    [27.5,  4.500, "Pipe4XXS",    "PIPE"],
  "PIPE5STD":    [14.6,  5.563, "Pipe5Std",    "PIPE"], "PIPE5XS":     [20.8,  5.563, "Pipe5XS",     "PIPE"],
  "PIPE5XXS":    [38.6,  5.563, "Pipe5XXS",    "PIPE"],
  "PIPE6STD":    [19.0,  6.625, "Pipe6Std",    "PIPE"], "PIPE6XS":     [28.6,  6.625, "Pipe6XS",     "PIPE"],
  "PIPE6XXS":    [53.2,  6.625, "Pipe6XXS",    "PIPE"],
  "PIPE8STD":    [28.6,  8.625, "Pipe8Std",    "PIPE"], "PIPE8XS":     [43.4,  8.625, "Pipe8XS",     "PIPE"],
  "PIPE8XXS":    [72.4,  8.625, "Pipe8XXS",    "PIPE"],
  "PIPE10STD":   [40.5, 10.750, "Pipe10Std",   "PIPE"], "PIPE10XS":    [54.7, 10.750, "Pipe10XS",    "PIPE"],
  "PIPE12STD":   [49.6, 12.750, "Pipe12Std",   "PIPE"], "PIPE12XS":    [65.4, 12.750, "Pipe12XS",    "PIPE"],
  "PIPE12DBLXS": [108,  12.750, "Pipe12DblXS", "PIPE"],
};

// ─── Normalizer ───────────────────────────────────────────────────────────────
// Converts user input to the canonical lookup key.
// "w 8 x 31" → "W8X31"   "hss4x4x1/4" → "HSS4X4X1/4"
export function normalizeDesignation(input) {
  if (!input) return "";
  return input.trim().toUpperCase().replace(/\s+/g, "");
}

// ─── Lookup ───────────────────────────────────────────────────────────────────
/**
 * Look up an AISC shape by EDI designation.
 * Returns { label, weight, d, shape } or null if not found.
 */
export function lookupShape(designation) {
  const key = normalizeDesignation(designation);
  if (!key) return null;
  const entry = RAW[key];
  if (!entry) return null;
  const [weight, d, label, shape] = entry;
  return { label, weight, d, shape };
}

/**
 * Returns candidate keys that start with the given prefix (for autocomplete/hints).
 * Limit to first 20 matches.
 */
export function suggestShapes(prefix, limit = 20) {
  const norm = normalizeDesignation(prefix);
  if (!norm || norm.length < 2) return [];
  return Object.keys(RAW)
    .filter((k) => k.startsWith(norm))
    .slice(0, limit);
}

export default RAW;
